import React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

export default function JoinEventButton({ variant, children, disabled }) {
  return (
    <Stack spacing={2} direction="row">
      <Button variant={variant} disabled={disabled}>{children}</Button>
    </Stack>
  );
}
